import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./App";
import "bootstrap/dist/css/bootstrap.min.css";

import "./assets/css/fontawesome-all.css";
import "./assets/css/animate.min.css";
import "./assets/css/custom.css";

import "./assets/scss/style.scss";

import "bootstrap";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
